import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
	Elements,
	CardCvcElement,
	CardNumberElement,
	CardExpiryElement,
	useStripe,
	useElements
} from '@stripe/react-stripe-js';
import { LoadingOutlined, CreditCardOutlined, CheckOutlined } from '@ant-design/icons';
import { Card, Button, Form, Typography, Spin, Modal, Col, Row, Input, Space } from 'antd';
import CardVisa from '../../assets/CardVisa.png';
import CardMasterCard from '../../assets/CardMasterCard.svg';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { showPay, payEnd } from '../../store/data/actions';
import { isMobileOnly, isTablet } from 'react-device-detect';
import { stages } from '../../store/auth/actions';
import env from '../../environment';
import { useTranslation } from 'react-i18next';
import { purchase } from '../../components/tagmanager';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { trace } from '../../components/tagmanager';

const { Text } = Typography;
const stripePromise = loadStripe(`${env.stripe.public_key}`);

const CheckoutForm = ({
	clientSecretToken,
	amount,
	mortgageId,
	userMortgageId,
	firtsPaydocuments,
	setModalPay,
	setshowCheckout,
	getDataOperation
}) => {
	const { t } = useTranslation();
	const stripe = useStripe();
	const elementsCard = useElements();
	const [, setError] = useState(null);
	const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;
	const userToken = useSelector((state) => state.auth.token);
	const [loading] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const location = useLocation();
	const rol = useSelector((state) => state.auth.roles);
	const { operationId } = useParams();
	const [nameOperations, setNameOperations] = useState(undefined);

	useEffect(() => {
		axios
			.get(`${env.api.url}/v1/operations/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setNameOperations(response.data.data.name);

				trace({
					location,
					userToken,
					rol,
					stage: 'full_02_card_payment',
					operationName: response.data.data
					//extra: operationsData
				});
			});
	}, []);

	const saveData = (participant, key, value) => {
		axios
			.post(
				`${env.api.url}/v1/mortgages/data/update/${mortgageId}`,
				{ key, participant, value },
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				console.log(response);
				getDataOperation();
			});
	};

	const dataMultiple = (key, owner, value, key1, owner1, value1) => {
		axios
			.post(
				`${env.api.url}/v1/mortgages/data/multiple/update/${userMortgageId}`,
				{
					values: [
						{
							key: key,
							subkey: owner,
							value: value
						},
						{
							key: key1,
							subkey: owner1,
							value: value1
						}
					]
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				console.log(response);
			});
	};

	const modalSuccess = () => {
		Modal.success({
			className: 'ModalCommonConfirmPaid',
			title: t('m_payment.confirmTitle1') + t('m_payment.confirmTitle2'),
			icon: null,
			okText: t('viability.continue'),
			okType: 'primary',
			content: (
				<div>
					{' '}
					<Text>{t('m_payment.confirmTitle3')}</Text>
				</div>
			),
			onOk() {
				navigate(`/operations/${userMortgageId}/full`);
				dispatch(stages('full'));
				dataMultiple(
					'payments',
					'refundableDepositPaid',
					'Si',
					'payments',
					'refundableDepositAmount',
					amount ? amount : '50'
				);
			}
		});
	};

	const handleSubmit = async () => {
		let payload = '';

		if (amount !== undefined) {
			try {
				payload = await stripe.confirmCardPayment(`${clientSecretToken}`, {
					payment_method: {
						card: elementsCard.getElement(CardExpiryElement)
					}
				});
			} catch (e) {
				console.log('holaa' + e.message);
			}
			if (payload.error) {
				setError(`Payment failed ${payload.error.message}`);
				alert(`Tu pago ha fallado ${payload.error.message}`);
			} else {
				purchase({ userToken, purchase: amount });
				alert('Tu pago ha sido procesado correctamente');
				dispatch(showPay(false));
				dispatch(payEnd(true));
				saveData('mortgage', 'appraisalPaid', true);
				if (firtsPaydocuments && !isMobileOnly) {
					setshowCheckout(false);
					setModalPay(false);
				} else if (firtsPaydocuments && isMobileOnly) {
					setshowCheckout(false);
					setModalPay(false);
					navigate(`/operations/${userMortgageId}/documents`);
				}
			}
		}

		if (amount === undefined) {
			payload = await stripe.confirmCardPayment(`${clientSecretToken}`, {
				payment_method: {
					card: elementsCard.getElement(CardExpiryElement)
				}
			});

			if (payload.error) {
				setError(`Payment failed ${payload.error.message}`);
				alert(`Tu pago ha fallado ${payload.error.message}`);
			} else {
				modalSuccess();
			}
		}

		if (payload.error) {
			setError(`Payment failed ${payload.error.message}`);
			alert(`Tu pago ha fallado ${payload.error.message}`);
		}
	};

	return (
		<div>
			{nameOperations && (
				<>
					<Card
						style={{
							margin: isMobileOnly ? 'auto' : 'auto 40px',
							marginTop: isMobileOnly && 16,
							width: !isMobileOnly ? 'calc(100% - 80px)' : 'auto',
							alignItems: 'center',
							boxShadow: '0px 0px 8px rgba(47, 72, 88, 0.1)',
							color: ''
						}}>
						<div style={{ margin: 'auto' }}>
							<Text>
								{amount
									? t('viability.textPaidmentAppraisalviability') + ' ' + amount + '€'
									: t('viability.textPaidmentBasicviability')}
							</Text>

							<Form onFinish={handleSubmit} style={{ marginTop: '20px' }} layout="vertical">
								<Form.Item label={t('appraisal.emailSecure')} name="email">
									<Input
										className="styleInput"
										placeholder={t('appraisal.emailSecure')}
										style={{ maxWidth: '100%' }}
									/>
								</Form.Item>
								<Form.Item label={t('appraisal.InfoSecure')} noStyle>
									<Text>{t('appraisal.InfoSecure')}</Text>
									<div className="styleInput" style={{ display: 'flex', marginTop: 6 }}>
										<div
											role="group"
											aria-label="Card number"
											style={{ width: isMobileOnly ? '84%' : '50%' }}>
											<CardNumberElement options={{ ariaLabel: 'Card number' }} />
										</div>
										<Space style={{ marginTop: 6 }}>
											<img src={CardVisa} alt="CardVisa logo" height={isMobileOnly ? 12 : 16} />
											<img
												src={CardMasterCard}
												alt="MasterCard logo"
												height={isMobileOnly ? 20 : 24}
											/>
										</Space>
									</div>
									<div
										role="group"
										aria-label="Card expirationd and security code"
										style={{ display: 'flex', marginTop: 8 }}>
										<div className="styleInput" style={{ width: '50%', marginRight: 8 }}>
											<div style={{ width: '84%' }}>
												<CardExpiryElement options={{ ariaLabel: 'Expiration date' }} />
											</div>
										</div>
										<div className="styleInput" style={{ width: '50%' }}>
											<div style={{ width: '84%' }}>
												<CardCvcElement options={{ ariaLabel: 'CVC' }} />
											</div>
											<CreditCardOutlined style={{ float: 'right', marginTop: '2px' }} />
										</div>
									</div>
								</Form.Item>
								<Form.Item
									label={t('appraisal.NameSecure')}
									name="name"
									style={{ marginTop: 20 }}
									tooltip={null}>
									<Input
										className="styleInput"
										placeholder={t('appraisal.NameSecure')}
										style={{ maxWidth: '100%' }}
									/>
								</Form.Item>
								<Button
									htmlType="submit"
									className="button-primari-gibobs"
									type="primary"
									style={{ marginTop: '20px', width: '100%', fontSize: '14px' }}
									disabled={!stripe}>
									{loading ? <Spin indicator={antIcon} className="spin" /> : t('appraisal.pay')}
								</Button>
							</Form>
						</div>
					</Card>
				</>
			)}
		</div>
	);
};

function CheckOutPrueba({
	clientSecretToken,
	amount,
	showPayBoolean,
	mortgageId,
	userMortgageId,
	dataClient,
	firtsPaydocuments,
	setshowCheckout,
	setModalPay,
	getDataOperation
}) {
	return (
		<Elements stripe={stripePromise}>
			<CheckoutForm
				clientSecretToken={clientSecretToken}
				amount={amount}
				showPayBoolean={showPayBoolean}
				mortgageId={mortgageId}
				userMortgageId={userMortgageId}
				dataClient={dataClient}
				firtsPaydocuments={firtsPaydocuments}
				setshowCheckout={setshowCheckout}
				setModalPay={setModalPay}
				getDataOperation={getDataOperation}
			/>
		</Elements>
	);
}

export default CheckOutPrueba;
